import {combineReducers} from 'redux';
import {configureStore} from '@reduxjs/toolkit';

import productDataReducer from './slices/productDataSlice';
import statusReducer from './slices/statusSlice';
import priceReducer from './slices/priceSlice';
import shortNumberReducer from './slices/shortNumberSlice';
import downloadReducer from './slices/downloadSlice';
import configurationReducer from './slices/configurationSlice';
import userReducer from './slices/userSlice';
import specsheetReducer from './slices/specsheetSlice';
import spcReducer from './slices/spcSlice';

import solarReducer from './solar/solarSlice';
import lightProfileReducer from './lightProfile/lightProfileSlice';
import olivioReducer from './olivio/olivioSlice';

import {sectionConfigMiddleware} from './middleware/sectionConfigMiddleware';
import {priceMiddleware} from './middleware/priceMiddleware';
import {shortArticleNumberMiddleware} from './middleware/shortArticleNumberMiddleware';
import {llmfMiddleware} from './middleware/llmfMiddleware';
import {dataStorageMiddleware} from './middleware/dataStorageMiddleware';
import {augmentProductDataMiddleware} from './middleware/augmentProductDataMiddleware';
import {reluxMiddleware} from './middleware/reluxMiddleware';
import {kirbySpecsheetMiddleware} from './middleware/kirbySpecsheetMiddleware';
import {sessionMiddleware} from './middleware/sessionMiddleware';

import {lightProfileMiddleware} from './lightProfile/lightProfileMiddleware';
import {solarMiddleware} from './solar/solarMiddleware';
import {olivioMiddleware} from './olivio/olivioMiddleware';
import {cableMiddleware} from './middleware/cableMiddleware';
import {finalizedMiddleware} from './middleware/finalizedMiddleware';


const store = configureStore({

	reducer: combineReducers({
		configuration: configurationReducer,
		productData: productDataReducer,
		status: statusReducer,
		price: priceReducer,
		shortNumber: shortNumberReducer,
		download: downloadReducer,
		lightProfile: lightProfileReducer,
		userProfile: userReducer,
		solar: solarReducer,
		specsheet: specsheetReducer,
		spc: spcReducer,
		olivio: olivioReducer
	}),
	devTools: process.env.NODE_ENV !== 'production',

	middleware: (getDefaultMiddleware) => getDefaultMiddleware({
		serializableCheck: false
	}).concat(
		//sectionConfigMiddleware,
		dataStorageMiddleware,
		priceMiddleware,
		llmfMiddleware,
		//augmentProductDataMiddleware,
		solarMiddleware,
		shortArticleNumberMiddleware,
		//reluxMiddleware,
		lightProfileMiddleware,
		//productDataMiddleware,
		olivioMiddleware,
		kirbySpecsheetMiddleware,
		sessionMiddleware,
		cableMiddleware,
		finalizedMiddleware
	)

});


export default store;
